export type AssetKind =
  | 'video'
  | 'excel'
  | 'document'
  | 'pdf'
  | 'text'
  | 'csv'
  | 'file';

export type ModuleAsset = {
  name: string;
  kind: AssetKind;
  size: string;
  s3Key: string;
  minimumQualifiedDurationMs?: number | null;
};

export type ModuleFolder = {
  id: string;
  name: string;
  date: string;
  time: string;
  files: ModuleAsset[];
};

export const moduleFolders: ModuleFolder[] = [
  {
    id: 'topic-1-1',
    name: 'Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs',
    date: '01.05.2026',
    time: '4:29',
    files: [
      {
        name: '1.1.mp4',
        kind: 'video',
        size: '696.7 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/1.1.mp4',
      },
      {
        name: 'CAIO_RACI_Matrix_Template_EN.xlsx',
        kind: 'excel',
        size: '5.4 KB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/CAIO_RACI_Matrix_Template_EN.xlsx',
      },
      {
        name: 'Conclusion.mp4',
        kind: 'video',
        size: '110.3 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Conclusion.mp4',
      },
      {
        name: 'Instructions_for_Students_1.1.txt',
        kind: 'text',
        size: '596 B',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Instructions_for_Students_1.1.txt',
      },
      {
        name: 'Introduction to practice.mp4',
        kind: 'video',
        size: '139.9 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Introduction to practice.mp4',
      },
      {
        name: 'Screencast 1.1.mp4',
        kind: 'video',
        size: '243.3 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Screencast 1.1.mp4',
      },
      {
        name: 'Structured Reflection.mp4',
        kind: 'video',
        size: '10.5 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Structured Reflection.mp4',
      },
      {
        name: 'Task 1.1.mp4',
        kind: 'video',
        size: '115.9 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Task 1.1.mp4',
      },
      {
        name: 'Task 1.2.mp4',
        kind: 'video',
        size: '103.9 MB',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/Task 1.2.mp4',
      },
      {
        name: 'table.csv',
        kind: 'csv',
        size: '90 B',
        s3Key:
          'edu/1 module/Topic 1.1. The Profession of Chief AI Officer. Area of Responsibility, Mandate, KPIs/table.csv',
      },
    ],
  },
  {
    id: 'topic-1-2',
    name: 'Topic 1.2. Classical ML, CV, GenAI: Differences in Data, Timelines, Costs, and Infrastructure',
    date: '01.05.2026',
    time: '4:30',
    files: [
      {
        name: '1.2.mp4',
        kind: 'video',
        size: '857.5 MB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/1.2.mp4',
      },
      {
        name: 'Activ 1.mp4',
        kind: 'video',
        size: '114.3 MB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/Activ 1.mp4',
      },
      {
        name: 'Activ 2.mp4',
        kind: 'video',
        size: '72.4 MB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/Activ 2.mp4',
      },
      {
        name: 'Activ 3.mp4',
        kind: 'video',
        size: '103.3 MB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/Activ 3.mp4',
      },
      {
        name: 'Industry_AI_Case_Studies_for_Seminar_EN.xlsx',
        kind: 'excel',
        size: '9.5 KB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/Industry_AI_Case_Studies_for_Seminar_EN.xlsx',
      },
      {
        name: 'Introduction.mp4',
        kind: 'video',
        size: '7.8 MB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/Introduction.mp4',
      },
      {
        name: 'ML_CV_GenAI_Lifecycle_Comparison_EN.xlsx',
        kind: 'excel',
        size: '7.4 KB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/ML_CV_GenAI_Lifecycle_Comparison_EN.xlsx',
      },
      {
        name: 'ML_vs_GenAI_Decision_Checklist_7Questions_EN.xlsx',
        kind: 'excel',
        size: '9.3 KB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/ML_vs_GenAI_Decision_Checklist_7Questions_EN.xlsx',
      },
      {
        name: 'Screencast 1.2.mp4',
        kind: 'video',
        size: '315.6 MB',
        s3Key:
          'edu/1 module/Topic 1.2. Classical ML_ CV_ GenAI_ Differences in Data_ Timelines_ Costs_ and Infrastructure/Screencast 1.2.mp4',
      },
    ],
  },
  {
    id: 'topic-1-3',
    name: 'Topic 1.3. LLMs in the Language of Business: Tokens, Hallucinations, Grounding',
    date: '01.05.2026',
    time: '4:30',
    files: [
      {
        name: '1.3.mp4',
        kind: 'video',
        size: '1.6 GB',
        s3Key:
          'edu/1 module/Topic 1.3. LLMs in the Language of Business_ Tokens_ Hallucinations_ Grounding/1.3.mp4',
      },
    ],
  },
  {
    id: 'topic-1-5',
    name: 'Topic 1.5. The AI Maturity Model',
    date: '01.05.2026',
    time: '4:31',
    files: [
      {
        name: '1.5.mp4',
        kind: 'video',
        size: '977.2 MB',
        s3Key: 'edu/1 module/Topic 1.5. The AI Maturity Model/1.5.mp4',
      },
      {
        name: 'AI_Governance_Risk_Register.xlsx',
        kind: 'excel',
        size: '6.4 KB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/AI_Governance_Risk_Register.xlsx',
      },
      {
        name: 'AI_Maturity_Assessment_Workbook.xlsx',
        kind: 'excel',
        size: '5.8 KB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/AI_Maturity_Assessment_Workbook.xlsx',
      },
      {
        name: 'AI_Maturity_Model_Study_Guide.docx',
        kind: 'document',
        size: '16.5 KB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/AI_Maturity_Model_Study_Guide.docx',
      },
      {
        name: 'AI_Transformation_Roadmap.xlsx',
        kind: 'excel',
        size: '6.3 KB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/AI_Transformation_Roadmap.xlsx',
      },
      {
        name: 'Boardroom_AI_Executive_Brief.docx',
        kind: 'document',
        size: '18.3 KB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/Boardroom_AI_Executive_Brief.docx',
      },
      {
        name: 'Screencast 1.5 2.mp4',
        kind: 'video',
        size: '481.3 MB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/Screencast 1.5 2.mp4',
      },
      {
        name: 'Screencast 1.5 3.mp4',
        kind: 'video',
        size: '335.9 MB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/Screencast 1.5 3.mp4',
      },
      {
        name: 'Screencast 1.5.mp4',
        kind: 'video',
        size: '490.8 MB',
        s3Key:
          'edu/1 module/Topic 1.5. The AI Maturity Model/Screencast 1.5.mp4',
      },
    ],
  },
  {
    id: 'topic-1-6',
    name: 'Topic 1.6. 10 GenAI Implementation Anti-patterns',
    date: '01.05.2026',
    time: '4:31',
    files: [
      {
        name: '1.6.mp4',
        kind: 'video',
        size: '2.4 GB',
        s3Key:
          'edu/1 module/Topic 1.6. 10 GenAI Implementation Anti-patterns/1.6.mp4',
      },
    ],
  },
  {
    id: 'topic-1-7',
    name: 'Topic 1.7. Acceptable Use Policy (AUP)',
    date: '01.05.2026',
    time: '4:31',
    files: [
      {
        name: '1.7 v.mp4',
        kind: 'video',
        size: '228.2 MB',
        s3Key: 'edu/1 module/Topic 1.7. Acceptable Use Policy (AUP)/1.7 v.mp4',
      },
      {
        name: 'ACCEPTABLE USE POLICY (AUP) FOR GENERATIVE ARTIFICIAL INTELLIGENCE.docx',
        kind: 'document',
        size: '16.2 KB',
        s3Key:
          'edu/1 module/Topic 1.7. Acceptable Use Policy (AUP)/ACCEPTABLE USE POLICY (AUP) FOR GENERATIVE ARTIFICIAL INTELLIGENCE.docx',
      },
      {
        name: 'GenAI_Employee_Instructions_v1.0_EN.docx',
        kind: 'document',
        size: '15.3 KB',
        s3Key:
          'edu/1 module/Topic 1.7. Acceptable Use Policy (AUP)/GenAI_Employee_Instructions_v1.0_EN.docx',
      },
    ],
  },
  {
    id: 'topic-1-8',
    name: 'Topic 1.8 Quick Data Readiness Assessment',
    date: '14.05.2026',
    time: '4:30',
    files: [
      {
        name: '1.8.mp4',
        kind: 'video',
        size: '1.0 GB',
        s3Key: 'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/1.8.mp4',
      },
      {
        name: '10-Step Data Readiness Checklist.xlsx',
        kind: 'excel',
        size: '5.4 KB',
        s3Key:
          'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/10-Step Data Readiness Checklist.xlsx',
      },
      {
        name: 'Assignment Success Criteria.xlsx',
        kind: 'excel',
        size: '4.9 KB',
        s3Key:
          'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/Assignment Success Criteria.xlsx',
      },
      {
        name: 'Decision Rules.xlsx',
        kind: 'excel',
        size: '4.7 KB',
        s3Key:
          'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/Decision Rules.xlsx',
      },
      {
        name: 'Example (Filled Checklist).xlsx',
        kind: 'excel',
        size: '5.2 KB',
        s3Key:
          'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/Example (Filled Checklist).xlsx',
      },
      {
        name: 'Summary Table.xlsx',
        kind: 'excel',
        size: '4.8 KB',
        s3Key:
          'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/Summary Table.xlsx',
      },
      {
        name: 'Template for Filling.xlsx',
        kind: 'excel',
        size: '4.8 KB',
        s3Key:
          'edu/1 module/Topic 1.8 Quick Data Readiness Assessment/Template for Filling.xlsx',
      },
    ],
  },
  {
    id: 'video-lecture-1-4',
    name: 'Video Lecture 1.4. The GenAI Value Map in Business: Where It Is Already Implemented and the Impact It Delivers',
    date: '01.05.2026',
    time: '4:31',
    files: [
      {
        name: '1.4 screencast.mp4',
        kind: 'video',
        size: '737.9 MB',
        s3Key:
          'edu/1 module/Video Lecture 1.4. The GenAI Value Map in Business_ Where It Is Already Implemented and the Impact It Delivers/1.4 screencast.mp4',
      },
      {
        name: '1.4.mp4',
        kind: 'video',
        size: '1.7 GB',
        s3Key:
          'edu/1 module/Video Lecture 1.4. The GenAI Value Map in Business_ Where It Is Already Implemented and the Impact It Delivers/1.4.mp4',
      },
      {
        name: 'Case Analysis: Real GenAI Business Implementations.docx',
        kind: 'document',
        size: '13.3 KB',
        s3Key:
          'edu/1 module/Video Lecture 1.4. The GenAI Value Map in Business_ Where It Is Already Implemented and the Impact It Delivers/Case Analysis_ Real GenAI Business Implementations.docx',
      },
      {
        name: 'GenAI_Glossary.pdf',
        kind: 'pdf',
        size: '2.6 KB',
        s3Key:
          'edu/1 module/Video Lecture 1.4. The GenAI Value Map in Business_ Where It Is Already Implemented and the Impact It Delivers/GenAI_Glossary.pdf',
      },
      {
        name: 'GenAI_Seminar_Student_Toolkit.xlsx',
        kind: 'excel',
        size: '9.6 KB',
        s3Key:
          'edu/1 module/Video Lecture 1.4. The GenAI Value Map in Business_ Where It Is Already Implemented and the Impact It Delivers/GenAI_Seminar_Student_Toolkit.xlsx',
      },
    ],
  },
];
